export default "__VITE_ASSET__CRRyPRPI__"